import { render, staticRenderFns } from "./AppWijzigen.vue?vue&type=template&id=f1a3d3b4&scoped=true&"
import script from "./AppWijzigen.ts?vue&type=script&lang=ts&"
export * from "./AppWijzigen.ts?vue&type=script&lang=ts&"
import style0 from "./AppWijzigen.scss?vue&type=style&index=0&id=f1a3d3b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a3d3b4",
  null
  
)

export default component.exports